import Vue from 'vue'
import VueRouter from 'vue-router'
import Accueil from "@/views/Accueil";
import Codename from "@/components/codename";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Accueil',
        component: Accueil
    }
    ,
    {
        path: '/:id',
        name: 'Codenames',
        component: Codename
    }
    /*{
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/!* webpackChunkName: "about" *!/ '../views/About.vue')
    }*/
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
